var _require = require('preact/compat'),
    _render = _require.render,
    hydrate = _require.hydrate,
    unmountComponentAtNode = _require.unmountComponentAtNode;

function createRoot(container) {
  return {
    // eslint-disable-next-line
    render: function render(children) {
      _render(children, container);
    },
    // eslint-disable-next-line
    unmount: function unmount() {
      unmountComponentAtNode(container);
    }
  };
}

exports.createRoot = createRoot;

exports.hydrateRoot = function (container, children) {
  hydrate(children, container);
  return createRoot(container);
};